import { render } from "./StepItem.vue?vue&type=template&id=4b85fa84"
import script from "./StepItem.vue?vue&type=script&lang=js"
export * from "./StepItem.vue?vue&type=script&lang=js"

import "./StepItem.vue?vue&type=style&index=0&id=4b85fa84&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__